module.exports = __webpack_public_path__ + "static/img/background.a58886b7.svg";